import { render, staticRenderFns } from "./hisGrid.vue?vue&type=template&id=863a7a0a&scoped=true&"
import script from "./hisGrid.vue?vue&type=script&lang=js&"
export * from "./hisGrid.vue?vue&type=script&lang=js&"
import style0 from "./hisGrid.vue?vue&type=style&index=0&id=863a7a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863a7a0a",
  null
  
)

export default component.exports